import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentApiService } from '@uc/web/config';
import { Apollo } from 'apollo-angular';
import {
	GET_CLEARING_COURSES,
	GET_COURSES,
	GET_UNIVERSITY_CLEARING_COURSES,
	GET_UNIVERSITY_COURSES,
} from './queries.graphql';
import { firstValueFrom, map } from 'rxjs';
import { CourseSearch } from '../models/course-search.models';
import { ClearingCourseSearch } from '../models/clearing-course-search.models';
import {
	SingleClearingCourseSearchUni,
	SingleCourseSearchUni,
} from '../models/single-uni-course-search.models';
import {
	CourseSearchPayload,
	UniversityCourseSearchPayload,
} from '../models/course-search-payload.models';
import { CoursesHubLink, TopDegreeSubject } from '../models/course-degree-hub.models';
import { DegreeLevelPayload } from '@uc/web/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class CourseSearchApiService {
	constructor(
		private _apollo: Apollo,
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	getCourseList(args: CourseSearchPayload) {
		return this._apollo
			.query<{
				courses: CourseSearch;
				loading: boolean;
				networkStatus: number;
			}>({
				query: GET_COURSES,
				variables: args,
			})
			.pipe(map(({ data }) => data.courses));
	}

	getUniversityCourses(args: UniversityCourseSearchPayload) {
		return this._apollo
			.query<{ universityCourses: SingleCourseSearchUni }>({
				query: GET_UNIVERSITY_COURSES,
				variables: args,
			})
			.pipe(map(({ data }) => data.universityCourses));
	}

	getClearingCourseList(args: CourseSearchPayload) {
		return this._apollo
			.query<{
				clearingCourses: ClearingCourseSearch;
				loading: boolean;
				networkStatus: number;
			}>({
				query: GET_CLEARING_COURSES,
				variables: args,
			})
			.pipe(map(({ data }) => data.clearingCourses));
	}

	getUniversityClearingCourses(args: UniversityCourseSearchPayload) {
		return this._apollo
			.query<{ clearingUniversityCourses: SingleClearingCourseSearchUni }>({
				query: GET_UNIVERSITY_CLEARING_COURSES,
				variables: args,
			})
			.pipe(map(({ data }) => data.clearingUniversityCourses));
	}

	getDegreeLevelHubLinks(type: 'DEGREE' | 'DIRECTORY') {
		return firstValueFrom(
			this._http.get<CoursesHubLink[]>(
				`${this._apiSrv.API_URL}courses/hubs?type=${type}`,
			),
		);
	}

	getTopSubjects(type: 'DEGREE' | 'DIRECTORY', degreeLevel: DegreeLevelPayload) {
		return firstValueFrom(
			this._http.get<TopDegreeSubject[]>(
				`${this._apiSrv.API_URL}courses/hubs/degrees?type=${type}&degree_level=${degreeLevel}`,
			),
		);
	}
}
